import _toConsumableArray from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
/**
 * @license
 * Copyright 2023 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
import { image, serialization, tidy } from '@tensorflow/tfjs-core';
import { getExactlyOneTensor, getExactlyOneShape } from '../../utils/types_utils';
import { ValueError } from '../../errors';
import { BaseRandomLayer } from '../../engine/base_random_layer';
import { randomUniform } from '@tensorflow/tfjs-core';
var INTERPOLATION_KEYS = ['bilinear', 'nearest'];
export var INTERPOLATION_METHODS = new Set(INTERPOLATION_KEYS);
/**
 * Preprocessing Layer with randomly varies image during training
 *
 * This layer randomly adjusts the width of a batch of images of a
 * batch of images by a random factor.
 *
 * The input should be a 3D (unbatched) or
 * 4D (batched) tensor in the `"channels_last"` image data format. Input pixel
 * values can be of any range (e.g. `[0., 1.)` or `[0, 255]`) and of interger
 * or floating point dtype. By default, the layer will output floats.
 *
 * tf methods implemented in tfjs: 'bilinear', 'nearest',
 * tf methods unimplemented in tfjs: 'bicubic', 'area', 'lanczos3', 'lanczos5',
 *                                   'gaussian', 'mitchellcubic'
 *
 */
var RandomWidth = /*#__PURE__*/function (_BaseRandomLayer) {
  _inherits(RandomWidth, _BaseRandomLayer);
  function RandomWidth(args) {
    var _this;
    _classCallCheck(this, RandomWidth);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(RandomWidth).call(this, args));
    var factor = args.factor,
      _args$interpolation = args.interpolation,
      interpolation = _args$interpolation === void 0 ? 'bilinear' : _args$interpolation;
    _this.factor = factor;
    if (Array.isArray(_this.factor) && _this.factor.length === 2) {
      _this.widthLower = _this.factor[0];
      _this.widthUpper = _this.factor[1];
    } else if (!Array.isArray(_this.factor) && _this.factor > 0) {
      _this.widthLower = -_this.factor;
      _this.widthUpper = _this.factor;
    } else {
      throw new ValueError("Invalid factor: ".concat(_this.factor, ". Must be positive number or tuple of 2 numbers"));
    }
    if (_this.widthLower < -1.0 || _this.widthUpper < -1.0) {
      throw new ValueError("factor must have values larger than -1. Got: ".concat(_this.factor));
    }
    if (_this.widthUpper < _this.widthLower) {
      throw new ValueError("factor cannot have upper bound less than lower bound.\n        Got upper bound: ".concat(_this.widthUpper, ".\n        Got lower bound: ").concat(_this.widthLower, "\n      "));
    }
    if (interpolation) {
      if (INTERPOLATION_METHODS.has(interpolation)) {
        _this.interpolation = interpolation;
      } else {
        throw new ValueError("Invalid interpolation parameter: ".concat(interpolation, " is not implemented"));
      }
    }
    return _this;
  }
  _createClass(RandomWidth, [{
    key: "getConfig",
    value: function getConfig() {
      var config = {
        'factor': this.factor,
        'interpolation': this.interpolation
      };
      var baseConfig = _get(_getPrototypeOf(RandomWidth.prototype), "getConfig", this).call(this);
      Object.assign(config, baseConfig);
      return config;
    }
  }, {
    key: "computeOutputShape",
    value: function computeOutputShape(inputShape) {
      inputShape = getExactlyOneShape(inputShape);
      var numChannels = inputShape[2];
      return [this.imgHeight, -1, numChannels];
    }
  }, {
    key: "call",
    value: function call(inputs, kwargs) {
      var _this2 = this;
      return tidy(function () {
        var input = getExactlyOneTensor(inputs);
        _this2.imgHeight = input.shape[input.shape.length - 3];
        var imgWidth = input.shape[input.shape.length - 2];
        _this2.widthFactor = randomUniform([1], 1.0 + _this2.widthLower, 1.0 + _this2.widthUpper, 'float32', _this2.randomGenerator.next());
        var adjustedWidth = _this2.widthFactor.dataSync()[0] * imgWidth;
        adjustedWidth = Math.round(adjustedWidth);
        var size = [_this2.imgHeight, adjustedWidth];
        switch (_this2.interpolation) {
          case 'bilinear':
            return image.resizeBilinear(inputs, size);
          case 'nearest':
            return image.resizeNearestNeighbor(inputs, size);
          default:
            throw new Error("Interpolation is ".concat(_this2.interpolation, "\n          but only ").concat(_toConsumableArray(INTERPOLATION_METHODS), " are supported"));
        }
      });
    }
  }]);
  return RandomWidth;
}(BaseRandomLayer);
/** @nocollapse */
RandomWidth.className = 'RandomWidth';
export { RandomWidth };
serialization.registerClass(RandomWidth);